const Theme = {
  // sitecore returns
  Black: 'Black',
  White: 'White',
  // Design system wants
  Dark: 'dark',
  Light: 'light'
}

export default Theme
